import { createIntentType } from './intent';
export function createSetIntentType(label, create) {
    return createIntentType(label, {
        add (intent, state = new Set()) {
            state.add(intent);
            return state;
        },
        create,
        merge (target, source) {
            if (target) {
                source.forEach((i)=>target.add(i));
                return target;
            } else {
                return new Set(source);
            }
        }
    });
}

//# sourceMappingURL=createSetIntentType.js.map